import { defineMessages } from 'react-intl';

export default defineMessages({
  overwrite: {
    id: 'Customize teaser content',
    defaultMessage: 'Customize teaser content',
  },
  hrefDescription: {
    id: 'teaserHrefDescription',
    defaultMessage:
      'The block will be filled with the data from the selected content. If the subtitle is empty, it will be replaced by the category.',
  },
  overwriteDescription: {
    id: 'Check this option to customize this teaser. Leave it unchecked to display updates from the target content if it is edited later.',
    defaultMessage:
      'Check this option to customize this teaser. Leave it unchecked to display updates from the target content if it is edited later.',
  },
  // subtitleDescription: {
  //   id: 'If the subtitle is empty, it will be replaced by the category.',
  //   defaultMessage:
  //     'If the subtitle is empty, it will be replaced by the category.',
  // },
  subtitle: {
    id: 'Subtitle',
    defaultMessage: 'Subtitle',
  },
  aspectRatioMobile: {
    id: 'Aspect ratio - Mobile',
    defaultMessage: 'Aspect ratio - Mobile',
  },
  aspectRatioTablet: {
    id: 'Aspect ratio - Tablet',
    defaultMessage: 'Aspect ratio - Tablet',
  },
  aspectRatioDesktop: {
    id: 'Aspect ratio - Desktop',
    defaultMessage: 'Aspect ratio - Desktop',
  },
  aspectRatioMode: {
    id: 'Aspect ratio mode',
    defaultMessage: 'Image adjustment',
  },
  aspectRatioModeHelp: {
    id: 'Aspect ratio mode help',
    defaultMessage:
      'Fixed uses the selected aspect ratios by device. Free uses the natural image proportions.',
  },
  aspectRatioFixed: {
    id: 'Fixed',
    defaultMessage: 'Fixed',
  },
  aspectRatioFree: {
    id: 'Free',
    defaultMessage: 'Free (automatic height)',
  },
  aspectRatioHelp: {
    id: 'Select the image format for each device',
    defaultMessage: 'Select the image format for each device',
  },
  hideDescription: {
    id: 'Hide Description',
    defaultMessage: 'Hide Description',
  },
  hideImage: {
    id: 'Hide Image',
    defaultMessage: 'Hide Image',
  },
  hideSubtitleCategory: {
    id: 'Hide Subtitle/Category',
    defaultMessage: 'Hide Subtitle/Category',
  },
  resetTeaser: {
    id: 'Reset the block',
    defaultMessage: 'Reset the block',
  },
  refreshTeaser: {
    id: 'Refresh source content',
    defaultMessage: 'Refresh source content',
  },
  invalidTeaser: {
    id: 'Invalid teaser source',
    defaultMessage: 'Invalid teaser source',
  },
  verticalAlign: {
    id: 'Vertical align',
    defaultMessage: 'Vertical align',
  },
  horizontalAlign: {
    id: 'Horizontal align',
    defaultMessage: 'Horizontal align',
  },
  imageAlt: {
    id: 'Image description (alt text)',
    defaultMessage: 'Image description (alt text)',
  },
  imageAltDescription: {
    id: 'Describe the purpose of the image. Leave blank if the image is purely decorative.',
    defaultMessage:
      'Describe the purpose of the image. Leave blank if the image is purely decorative.',
  },
  imageAsBackground: {
    id: 'Use image as block background',
    defaultMessage: 'Use image as block background',
  },
  imageAsBackgroundDescription: {
    id: 'When checked, the text will be displayed over the image.',
    defaultMessage: 'When checked, the text will be displayed over the image.',
  },
  Default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  Image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  Fields: {
    id: 'Fields',
    defaultMessage: 'Fields',
  },
});
